module.exports = __webpack_public_path__ + "static/media/git.6c95b071.svg";